import { ApiErrorMap } from '@common/interfaces';
import { ErrorType } from '@lib/interfaces';

/**
 * prebookAPIのエラーレスポンスに対するエラーマップ
 */
export const SelectNextPageModalApiErrorMap: ApiErrorMap = {
  EBAZ000299: {
    isRetryableError: true,
    errorMsgId: 'E0758',
  },
  EBAZ000427: {
    isRetryableError: true,
    errorMsgId: 'E0457',
  },
  EBAZ000308: {
    isRetryableError: true,
    errorMsgId: 'E0467',
  },
  EBAZ000545: {
    isRetryableError: true,
    errorMsgId: 'E0852',
  },
  EBAZ000546: {
    isRetryableError: true,
    errorMsgId: 'E0854',
  },
  EBAZ000547: {
    isRetryableError: true,
    errorMsgId: 'E0855',
  },
  EBAZ000549: {
    isRetryableError: true,
    errorMsgId: 'E0856',
  },
  EBAZ000548: {
    isRetryableError: true,
    errorMsgId: 'E0857',
  },
  EBAZ000428: {
    isRetryableError: true,
    errorMsgId: 'E0456',
  },
  EBAZ000265: {
    isRetryableError: true,
    errorMsgId: 'E0707',
  },
  EBAZ000429: {
    isRetryableError: true,
    errorMsgId: 'E0708',
    replaceParams: {
      key: '0',
      value: 'label.advancedLounge',
    },
  },
  EBAZ000412: {
    isRetryableError: true,
    errorMsgId: 'E0455',
  },
  EBAZ000479: {
    isRetryableError: true,
    errorMsgId: 'E0451',
  },

  EBAZ000431: {
    isRetryableError: true,
    errorMsgId: 'E0452',
  },
  EBAZ000432: {
    isRetryableError: true,
    errorMsgId: 'E0452',
  },
  //'EBAZ000479':{
  // isRetryableError:true,
  // errorMsgId:'E0448',
  //},
  EBAZ000551: {
    isRetryableError: true,
    errorMsgId: 'E0859',
  },
  //FY25 追加分計 変更管理No.52 駅探BTM「BTOnline」
  EBAZ000529: {
    isRetryableError: true,
    errorMsgId: 'E0916',
  },
  //FY25 追加分計 変更管理No.52 駅探BTM「BTOnline」
  EBAZ000530: {
    isRetryableError: true,
    errorMsgId: 'E0917',
  },
  //FY25 追加分計 変更管理No.73 INFのQuota管理 INF制限数対応
  EBAZ000695: {
    isRetryableError: true,
    errorMsgId: 'E0918',
  },
  //障がい者割引運賃」かつ「障害者手帳情報-搭乗者選択情報」が未入力の場合
  EBAZ000559: {
    isRetryableError: true,
    errorMsgId: 'E1820',
  },
  //ANAUIUXS2_NH_DEV-4404 大人＋幼児のPNR上の搭乗者情報が59文字を超えた場合のDxAPIエラーの対応
  EBAZ000430: {
    isRetryableError: true,
    errorMsgId: 'E1771',
  },
  //継続不可エラー
  EBAZ000278: {
    isRetryableError: false,
    errorMsgId: 'E0333',
    errorType: ErrorType.BUSINESS_LOGIC,
  },
  EBAZ000422: {
    isRetryableError: false,
    errorMsgId: 'E0449',
    errorType: ErrorType.BUSINESS_LOGIC,
  },
  EBAZ000543: {
    isRetryableError: false,
    errorMsgId: 'E1317',
    errorType: ErrorType.BUSINESS_LOGIC,
  },
  EBAZ000842: {
    isRetryableError: false,
    errorMsgId: '',
    errorType: ErrorType.SYSTEM,
  },
};
